import shortid from 'shortid';
import _find from 'lodash/find';

import WS from '@/lib/ws.io';

import * as types from './mutation-types';
import { getApi } from '../comm/middleware/callApi';
import apis from '../comm/api/apis';
import reportLog from '../comm/middleware/reportLog';

export * from '@/store/expert/actions.expert';
export * from '@/store/user/actions.user';
export * from '@/store/nim/actions.nim';

/**
 * 通过socket发送消息
 * @param  {[type]} options.commit [description]
 * @param  {[type]} options.state  [description]
 * @param  {[type]} payload        自定义参数
 * @param  {[type]} payload.type        消息类型 *必填*
 * @param  {[type]} payload.content        消息内容 *非语音消息必填*
 * @param  {[type]} payload.speech        语音消息时长
 * @param  {[type]} payload.refMsgId        被回答问题 id
 * @param  {[type]} payload.mediaId        多媒体消息 id
 * @return {[type]}                [description]
 */
export const socketSendMessage = ({ commit, state }, payload) => {
  if (!payload.type) {
    commit(types.AJAX_ERROR, new Error('消息类型不能为空'));
  }
  if ((payload.type === 1 || payload.type === 3 || payload.type === 8) && !payload.content) {
    commit(types.AJAX_ERROR, new Error('消息内容不能为空'));
  }
  if ((payload.type === 7 || payload.type === 8) && !payload.refMsgId) {
    commit(types.AJAX_ERROR, new Error('回答消息refMsgId不能为空'));
  }
  if ((payload.type === 7 || payload.type === 6)) {
    console.log(`payload ===> ${JSON.stringify(payload)}`);
    if (payload.record === 1 && !payload.sucaiPicId) {
      commit(types.AJAX_ERROR, new Error('录播多媒体消息，sucaiPicId 不能为空'));
    }
    if (!payload.record && !payload.mediaId) {
      commit(types.AJAX_ERROR, new Error('多媒体消息，mediaId 不能为空'));
    }
  }

  const message = {
    type: payload.type,
    content: payload.content,
    mediaId: payload.mediaId || null,
    speech: payload.speech || null,
    refMsgId: payload.refMsgId || null,
    clientSeqId: payload.clientSeqId || shortid.generate(),
    sucaiPicId: payload.sucaiPicId || null
  };

  if (state.socket) {
    state.socket.send(JSON.stringify(message));
    console.log('state.connectStatus', state.connectStatus);
    if (!state.connectStatus) {
      const errormesg = '发送失败';
      commit(types.AJAX_ERROR, new Error(errormesg));
      message.uploadStatus = 0;
      this.sendLog({ commit, state }, {
        name: '消息发送失败',
        protocol: document.location.protocol === 'https:' ? 'https' : 'http',
        time: Date.parse(new Date()),
        socket: state.socket,
        url: location.href,
        msg: message,
        user: state.userInfo && state.userInfo.token ? state.userInfo : state.expertInfo,
        userType: state.userInfo && state.userInfo.token ? '用户端' : '专家端'
      });
    }
    commit(types.SOCKET_SEND_MESSAGE, {
      message
    });

    // 类型为 11 重置消息池
    if (message.type === 11) {
      commit(types.RESET_MESSAGE_STORE);
    }
  } else {
    commit(types.AJAX_ERROR, new Error('消息服务连接失败, 请退出或者刷新页面进行重连')); // FIXME: SOCKET 链接失败的情况，是不是需要添加重连的机制

    const msg = {
      name: '消息服务连接失败-socket失败',
      protocol: document.location.protocol === 'https:' ? 'https' : 'http',
      time: Date.parse(new Date()),
      socket: state.socket,
      url: location.href,
      msg: message,
      user: state.userInfo && state.userInfo.token ? state.userInfo : state.expertInfo,
      userType: state.userInfo && state.userInfo.token ? '用户端' : '专家端'
    };

    // 消息服务连接失败，发送日志
    reportLog(msg).then(() => {
      console.log('消息服务连接失败');
    });
  }
};

// 微信签名
export const wxSign = ({ commit, state }, { url, debug, sign = true, type }) => {
  let status = 0;
  commit(types.AJAX_WX_SIGN_STATUS, { status: 0 }); // 重签前还原签名状态
  console.log('微信签名地址：', url);
  const location = window.location.href;
  return getApi({ commit }, apis.wxSign, { url }).then((body) => {
    if (!body.signTO) {
      return Promise.reject({ err: new Error('微信签名失败'), ...body });
    }
    if (sign) {
      const { appid, timestamp, nonceStr, signature } = body.signTO;
      window.wx.config({
        debug: Boolean(debug), // 开启调试模式
        appId: appid, // 必填，公众号的唯一标识
        timestamp, // 必填，生成签名的时间戳
        nonceStr, // 必填，生成签名的随机串
        signature, // 必填，签名，见附录1
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'startRecord', 'stopRecord', 'onVoiceRecordEnd',
          'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice',
          'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getNetworkType',
          'hideOptionMenu', 'showOptionMenu', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'chooseWXPay', 'getLocation'
        ]
      });
      window.wx.ready(() => {
        console.log('微信签名成功-readey');
        status = 1;
        commit(types.AJAX_WX_SIGN_STATUS, { status });
        return Promise.resolve(status);
      });
      window.wx.error((res) => {
        console.log('微信签名失败-error');
        const signatureMsg = { appid, timestamp, nonceStr, signature, type, location };
        if (type === 'user') {
          signatureMsg.userInfo = state.userInfo;
        } else if (type === 'expert') {
          signatureMsg.expertInfo = state.expertInfo;
        }
        const msg = {
          name: `${type === 'expert' ? '专家端' : '用户端'}微信签名jssdk失败`,
          protocol: document.location.protocol === 'https:' ? 'https' : 'http',
          info: res,
          time: Date.parse(new Date()),
          url,
          signature: signatureMsg,
          userType: type === 'expert' ? `专家端-${type}` : `用户端-${type}`
        };
        reportLog(msg).then(() => {
          console.log('日志-微信签名接口失败');
        });
        status = 0;
        commit(types.AJAX_WX_SIGN_STATUS, { status });
      });
    }
    return Promise.resolve(status);
  }).catch((value) => {
    let reportMsg = value.reportMsg;
    if (reportMsg) {
      reportLog(reportMsg).then(() => {
        console.log('日志-微信签名失败');
      });
    } else {
      let err = value;
      const { appId = null, timeStamp = null, nonceStr = null, signature = null } = value;
      if (value.err) {
        err = value.err;
      }
      reportMsg = {
        name: '微信签名接口失败',
        protocol: document.location.protocol === 'https:' ? 'https' : 'http',
        info: err,
        time: Date.parse(new Date()),
        url,
        signature: { appId, timeStamp, nonceStr, signature, type, location },
        userType: type === 'expert' ? `专家端-${type}` : `用户端-${type}`
      };
    }
    commit(types.AJAX_ERROR, new Error('微信签名失败'));
    Promise.reject(0);
    // 微信签名接口失败，发送日志
    reportLog(reportMsg).then(() => {
      console.log('日志-微信签名接口失败');
    });
  });
};

// 关闭课程
export const closeCourse = ({ commit }, id) => {
  getApi({ commit }, apis.courseClose, id, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } }).then(() => {
    commit(types.COURSE_CLOSED, { status: 1 });
  });
};

// 关闭课程重置
export const closeCourseRest = ({ commit }) => {
  commit(types.COURSE_CLOSED, { status: -1 });
};

// 获取系列课列表数据 update by qiuhong 20130309
let serialListFetching = false;
export const getSerialList = ({ commit, state }, { curpage = 1, pageSize = 20, type = 1 }) => {
  if (serialListFetching) {
    return;
  }
  serialListFetching = true;
  getApi({ commit }, apis.serialList, { curpage, pageSize, type }).then((body) => {
    serialListFetching = false;
    const data = body.data;
    commit(types.SERIAL_LIST, { info: data, curpage, curType: type });
  }, () => {
    serialListFetching = false;
  });
};

// 获取树币info
export const getTreeCoinInfo = ({ commit }, { type = 'index', curpage, pageSize = 20 }) => {
  const apisUrl = type === 'index' ? apis.treeCoin : apis.treeCoinList;
  getApi({ commit }, apisUrl, { type, curpage, pageSize }).then((body) => {
    const dataInfo = body.data;
    if (dataInfo.list && dataInfo.pageNo !== 1) {
      commit(types.TREE_COIN_INFO_MORE, dataInfo);
    } else {
      commit(types.TREE_COIN_INFO, dataInfo);
    }
  });
};

// 获取消息
export const getMessages = ({ commit }, { courseId, lastId, direction = 0, onlyExpertMsg = true }) => {
  return getApi({ commit }, apis.historyMessage, { courseId, lastId, direction, onlyExpertMsg }).then((body) => {
    const messages = body.data.list;
    commit(types.AJAX_GET_MESSAGES, {
      lastId,
      messages
    });
    return messages;
  });
};

// 连接服务器
export const connectServer = (store, { liveId, userType = 'expert', onlyExpertMsg = 'false' }) => {
  const commit = store.commit;
  const state = store.state;
  let SERVER_ADDRESS;
  const protocol = document.location.protocol === 'https:' ? 'wss' : 'ws';
  const socketPort = document.location.protocol === 'https:' ? state.courseInfo.wssPort : state.courseInfo.wsPort;
  const timeStamp = state.signData.timeStamp;// new Date().getTime();

  if (userType === 'expert') {
    SERVER_ADDRESS = `${protocol}://${state.courseInfo.wsHost}:${socketPort}?userType=2&userId=${state.expertInfo.id}&userName=${state.expertInfo.name}&timestamp=${timeStamp}&token=${encodeURIComponent(state.expertInfo.token)}&courseId=${liveId}&onlyExpertMsg=${onlyExpertMsg}&sign=${state.signData.sign}&avatarPic=${encodeURIComponent(state.expertInfo.avatar)}&platform=h5`;
  } else if (userType === 'user') {
    SERVER_ADDRESS = `${protocol}://${state.courseInfo.wsHost}:${socketPort}?userType=1&encUserId=${state.userInfo.encUserId}&userName=${state.userInfo.name ? state.userInfo.name : '宝宝树用户'}&timestamp=${timeStamp}&token=${encodeURIComponent(state.userInfo.token)}&courseId=${liveId}&onlyExpertMsg=${onlyExpertMsg}&sign=${state.signData.sign}&avatarPic=${encodeURIComponent(state.userInfo.avatar)}&platform=h5`;
  }

  const socket = new WS(SERVER_ADDRESS, {
    reconnectionAttempts: 10, // 10次重连次数
    reconnectionDelay: 2500,
    timeout: 6000
  });

  socket.on('connect', () => {
    commit(types.SOCKET_CONNECT_STATUS, {
      status: 1
    });

    commit(types.SOCKET_CONNECT, {
      socket
    });

    window.clearInterval(window.messageInterval);
    window.messageInterval = setInterval(() => {
      let messages;
      if (state.messages.length === 0) {
        messages = state.messageStore.splice(0, state.messageStore.length);
      } else {
        messages = state.messageStore.splice(0, 1);
      }
      if (messages.length) {
        commit(types.SOCKET_RECEIVE_MESSAGE, {
          messages
        });
      }
    }, 1000);
  });

  // 监听 socket 消息
  socket.on('message', (message) => {
    const data = JSON.parse(message);
    console.log(`message type ===> ${data.type}`);
    console.log(`message ===> ${JSON.stringify(data)}`);
    console.log('%c[socket]', 'color: #49c9c9;', '实例监听 message', data.type);

    if (data.code !== 0 && data.code !== undefined) {
      if (data.code === 7 || data.code === 99) {
        const clientSeqId = data.data.clientSeqId;
        if (clientSeqId !== null) {
          const retryMessage = state.sendMessages[clientSeqId];
          if (retryMessage.retryCount === undefined) {
            retryMessage.retryCount = 0; // 初始化重试次数
          }

          if (retryMessage && retryMessage.retryCount < 3) {
            const errMsgStr = `消息发送失败，已重新发送[${retryMessage.retryCount + 1}/3]`;
            commit(types.AJAX_ERROR, new Error(errMsgStr));
            state.socket.send(JSON.stringify(retryMessage));
            retryMessage.retryCount += 1;
            // 如果监听到发送消息上传失败，则给该消息添加上标注
            const messageAry = state.messages;
            const messageLen = messageAry.length;
            const newFailMessage = messageAry[messageLen - 1];
            console.log('newFailMessage', newFailMessage);
            newFailMessage.uploadStatus = 0;
            // 添加标注结束
          } else {
            commit(types.AJAX_ERROR, new Error(data.errorMsg));
            //  消息发送失败日志
            this.sendLog(store, {
              name: '消息发送失败',
              protocol: document.location.protocol === 'https:' ? 'https' : 'http',
              info: message,
              time: Date.parse(new Date()),
              retryMessage,
              url: SERVER_ADDRESS,
              user: userType === 'expert' ? state.expertInfo : state.userInfo,
              userType: userType === 'expert' ? '专家端' : '用户端'
            });
          }
        }
      } else if (data.code === 2) {
        commit(types.AJAX_ERROR, new Error(data.errorMsg)); // 反垃圾必杀
      } else {
        commit(types.AJAX_ERROR, new Error(data.errorMsg));
      }
    } else {
      const messageAry = state.messages;
      const messageLen = messageAry.length;
      const newMessage = messageAry[messageLen - 1];
      // newMessage.uploadStatus = 1;
      console.log('newMessage-upload', newMessage);
      switch (data.type) {
        case 1: {
          state.messageStore = state.messageStore.concat(data.data.list);
          break;
        }
        case 15:
          commit(types.COURSE_CLOSED, { status: 1 });
          break;
        case 19:
          commit(types.COURSE_CLOSED, { status: 0 });
          break;
        case 17:
          commit(types.SOCKET_RECEIVE_MESSAGE_UP, {
            courseUpCount: data.data.count || 0
          });
          break;
        case 2: {
          if (data.data.msg) {
            const messages = [data.data.msg];
            // 反垃圾敏感词
            if (data.errorMsg) {
              commit(types.AJAX_ERROR, new Error(data.errorMsg));
            }
            commit(types.SOCKET_RECEIVE_MESSAGE, {
              messages,
              clientSeqId: data.data.clientSeqId
            });
          }
          // 如果提问信息，将次数信息提交到前台
          if (data.errorMsg && Number(data.data.msg.type) === 3) {
            commit(types.AJAX_ERROR, new Error(data.errorMsg));
          }
          break;
        }
        case 4: {
          if (data.data.refMsgId) {
            commit(types.SOCKET_RECEIVE_MESSAGE_LIKE_COUNT, {
              msgId: data.data.refMsgId,
              count: data.data.count
            });
          }
          break;
        }
        case 14: {
          // 删除消息
          if (data.data.refMsgId) {
            commit(types.SOCKET_RECEIVE_MESSAGE_DELETE, {
              msgId: data.data.refMsgId
            });
          }
          break;
        }
        default:
          break;
      }
    }
  });

  // 监听 socket 关闭
  socket.on('close', (reason) => {
    commit(types.SOCKET_CONNECT_STATUS, {
      status: 0
    });

    commit(types.SOCKET_CONNECT, {
      socket: null
    });

    console.log('%c[socket]', 'color: #49c9c9;', '实例监听 close', reason);

    if (userType === 'expert') {
      socket.uri = `${SERVER_ADDRESS}&lastId=${state.latestMessage.id}`;
    } else if (userType === 'user') {
      socket.uri = `${SERVER_ADDRESS}&lastId=${state.latestMessage.id}`;
    }

    const msg = {
      name: 'socket关闭',
      protocol: document.location.protocol === 'https:' ? 'https' : 'http',
      info: reason,
      time: Date.parse(new Date()),
      url: socket.uri,
      user: userType === 'expert' ? state.expertInfo : state.userInfo,
      userType: userType === 'expert' ? '专家端' : '用户端'
    };

    // 微信签名接口失败，发送日志
    reportLog(msg).then(() => {
      console.log('日志-socket 关闭');
    });
  });

  // 监听 socket 出错
  socket.on('error', (error) => {
    commit(types.SOCKET_CONNECT_STATUS, {
      status: 0
    });

    console.log('%c[socket]', 'color: #49c9c9;', '实例监听 error', error);
    console.error('[socket]', error);

    const msg = {
      name: 'socket出错',
      protocol: document.location.protocol === 'https:' ? 'https' : 'http',
      info: error,
      time: Date.parse(new Date()),
      url: SERVER_ADDRESS,
      user: userType === 'expert' ? state.expertInfo : state.userInfo,
      userType: userType === 'expert' ? '专家端' : '用户端'
    };

    // socket 出错，发送日志
    reportLog(msg).then(() => {
      console.log('日志-socket 出错');
    });
  });

  // 监听 socket 重连
  socket.on('reconnect_success', (attempt) => {
    console.log('%c[socket]', 'color: #49c9c9;', '实例监听 reconnect，重连成功，重新拉取消息', attempt);
    console.log('%c[socket]', 'color: #49c9c9;', '最后一条id:', state.latestMessage.id);
    console.log('%c[socket]', 'color: #49c9c9;', '是否只看主讲人:', userType === 'expert' ? window.VM.stateOnlyself : window.VM.isOnlyShowMaster);
  });

  // 重连出错
  socket.on('reconnect_error', (error) => {
    console.log('%c[socket]', 'color: #49c9c9;', '实例监听 reconnect_error, 重连失败');
    commit(types.AJAX_ERROR, new Error(`重连失败，已重试 [${error.attempts}/10]`));

    const msg = {
      name: 'socket重连出错',
      protocol: document.location.protocol === 'https:' ? 'https' : 'http',
      info: error,
      time: Date.parse(new Date()),
      url: SERVER_ADDRESS,
      user: userType === 'expert' ? state.expertInfo : state.userInfo,
      userType: userType === 'expert' ? '专家端' : '用户端'
    };

    // socket 重连，发送日志
    if (error.attempts > 9) {
      reportLog(msg).then(() => {
        console.log('日志-socket重连出错');
      });
    }
  });

  socket.on('reconnect_failed', () => {
    console.log('%c[socket]', 'color: #49c9c9;', '重连彻底失败');
    commit(types.AJAX_ERROR, new Error('重连失败，请退出或者刷新重试！'));
  });

  return true;
};

// 断开连接
export const disConnectServe = ({ state }) => {
  // socket 重连，发送日志
  if (state.socket) {
    state.socket.close(1000);
  }
};

// 音频开始加载
export const audioLoadstart = ({ commit }, { msgId }) => {
  commit(types.AUDIO_LOADSTART, { msgId });
};

// 音频开始播放
export const audioPlaying = ({ commit }, { msgId }) => {
  commit(types.AUDIO_PLAYING, { msgId });
};

// 音频停止播放
export const audioStop = ({ commit }, { msgId }) => {
  commit(types.AUDIO_STOP, { msgId });
};

/**
 * 重置消息数组
 * @param {[type]} store [description]
 */
export const resetMessage = (store) => {
  store.commit(types.RESET_MESSAGES);
};

/**
 * 设置loading
 * @param {[state]} store [description]
 * @param {[type]} store [description]
 */
export const setLoading = (store, { state, time }) => {
  if (time) {
    const loadingState = store.state.isLoading;
    setTimeout(() => {
      store.commit(types.AJAX_LOADING, { loadingStatus: loadingState });
    }, time);
  }
  store.commit(types.AJAX_LOADING, { loadingStatus: state });
};

// 课程详情
export const getCourseInfo = ({ commit, state }, { id, needfeatures = 0, code = '', parentcourseid, activeid }) => {
  const courseList = state.courseList;
  let courseInfo;
  if (courseList.data.length && !needfeatures) {
    courseInfo = _find(courseList.data, item => (item.id === id));
    commit(types.AJAX_GET_COURSEINFO, {
      courseInfo
      // filter: false,
    });
  } else {
    return getApi({ commit }, apis.courseDetail, { id, needfeatures, code, parentcourseid, activeid }).then((body) => {
      courseInfo = body.data;
      commit(types.AJAX_GET_COURSEINFO, {
        courseInfo,
        filter: true
      });
      return courseInfo;
    });
  }
  return courseInfo;
};

// 课程详情
export const getSerialCourselInfo = ({ commit }, { id, protocol, retry, code, newApi }) => {
  let apiUrl = apis.serialdetail;
  if (newApi) {
    apiUrl = apis.columndetail;
  }
  getApi({ commit }, apiUrl, { id, protocol, code }).then((body) => {
    if (!retry) {
      commit(types.AJAX_LOADING, { loadingStatus: false });
    }
    const courseInfo = body.data;
    commit(types.AJAX_GET_SERIALCOURSEINFO, {
      courseInfo
    });
  });
};

// 更多推荐课程
export const getCourseRecommends = ({ commit }, { courseid, type, subserial, parentcourseid, pagesize }) => {
  getApi({ commit }, apis.courseRecommend, { courseid, type, subserial, parentcourseid, pagesize }).then((body) => {
    const rs = body.data;
    commit(types.AJAX_GET_COURSE_RECOMMEND, {
      rs
    });
  });
};

// 获取标签页数据
const locationProtocol = document.location.protocol === 'https:' ? 'https' : 'http';
export const getTagsPage = ({ commit }, { labelid, sourse, protocol = locationProtocol }) => {
  return getApi({ commit }, apis.tags, { labelid, sourse, protocol }).then((body) => {
    const tagsInfo = body.data;
    return tagsInfo;
  });
};

// 获取标签聚合页数据
export const getTagsSubject = ({ commit }, { labelid, subjecttype, pagesize, curpage, protocol = locationProtocol }) => {
  return getApi({ commit }, apis.tagsSubject, { labelid, subjecttype, pagesize, curpage, protocol }).then((body) => {
    const tagsSubjectInfo = body.data;
    return tagsSubjectInfo;
  });
};

export const sendLog = ({ state }, payload) => {
  const initData = {
    name: '前端报错',
    protocol: document.location.protocol === 'https:' ? 'https' : 'http',
    info: '',
    time: Date.parse(new Date()),
    url: '',
    userType: state.userInfo && state.userInfo.token ? '用户端' : '专家端'
  };

  const msg = Object.assign({}, initData, payload);

  reportLog(msg).then(() => {
    console.log('发送日志成功');
  }).catch((e) => {
    console.log('发送日志成功', e);
  });
};



// WEBPACK FOOTER //
// ./src/store/actions.js